
import React from 'react';

const StarYellowUnderline = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='64'
			height='65'
			fill='none'
			viewBox='0 0 64 65'
		>
			<g fill='#FEE5B4' clipPath='url(#clip0)'>
				<path d='M46.28 52.508c-.32 0-.66-.08-.96-.24l-13.34-7.28-13.32 7.28c-.68.38-1.5.32-2.14-.14-.62-.46-.94-1.22-.78-1.98l2.8-14.94-11.06-10.44c-.56-.52-.76-1.34-.52-2.08s.88-1.26 1.64-1.36l15.08-1.94 6.5-13.74c.34-.7 1.04-1.14 1.82-1.14s1.48.44 1.8 1.14l6.5 13.74 15.08 1.94c.76.1 1.4.64 1.64 1.36.24.74.04 1.54-.52 2.08l-11.06 10.44 2.8 14.94c.14.76-.16 1.54-.78 1.98-.34.26-.76.38-1.18.38zM32 40.688c.34 0 .66.08.96.24l10.6 5.78-2.22-11.86c-.12-.66.1-1.36.6-1.82l8.78-8.28-11.98-1.54c-.68-.08-1.26-.52-1.56-1.12l-5.16-10.9-5.2 10.9c-.28.62-.88 1.04-1.54 1.12l-11.98 1.54 8.78 8.28c.5.46.72 1.16.6 1.82l-2.22 11.86 10.6-5.78c.28-.14.6-.24.94-.24zM53 60.508H11v4h42v-4z'></path>
			</g>
			<defs>
				<clipPath id='clip0'>
					<path
						fill='#fff'
						d='M0 0H64V64H0z'
						transform='translate(0 .508)'
					></path>
				</clipPath>
			</defs>
		</svg>
	);
};

export default StarYellowUnderline;
